import PropTypes from 'prop-types';
import React from 'react';
import TourCalendar from './TourCalendar';
import EventFilterToolbar from './EventFilterToolbar';

class TourCalendarTab extends React.Component {
  render() {
    return (
      <div className="col-sm-12 planner">
        <div className="panel">
          <EventFilterToolbar
            groups={this.props.tour.groups}
            filter={this.props.filter}
            eventFilterSet={this.props.eventFilterSet}
          />
          <TourCalendar
            tour={this.props.tour}
            filter={this.props.filter}
            readOnly={this.props.readOnly}
          />
        <p>* Calendar dates do not show the last day of multiple night stay. </p>
        </div>
      </div>
    );
  }
}
TourCalendarTab.propTypes = {
  tour: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  eventFilterSet: PropTypes.func.isRequired,
};
TourCalendarTab.defaultProps = {
  filter: {},
};
export default TourCalendarTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourCalendarTab.js